import { Link } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { asideIcons, asideTitles } from '../../functions/stateList'

function MenuItem({ name, active_name }) {
  const activeClassName = 'flex items-center dv-active '
  const inActiveClassName = 'flex items-center'

  let user_device = useSelector((state) => state?.deviceReducer?.device)

  return (
    <Link
      to={name === 'products' ? 'products/oil' : name}
      className={active_name === name ? activeClassName : inActiveClassName}
    >
      <i
        className={`${asideIcons[name]} text-2xl
        ${user_device === 'desktop' ? 'ml-2' : undefined}  
        ${
          active_name === name
            ? 'text-secondary dark:text-amber-50'
            : 'text-inactive-icon dark:text-slate-400'
        }`}
      />
      {user_device === 'desktop' && (
        <div
          className={
            active_name === name
              ? 'bg-light-blue dark:bg-slate-600 border-l-2 border-l-secondary rounded-r-md w-full p-2'
              : 'p-2'
          }
        >
          <span
            className={`text-lg ${
              active_name === name
                ? 'text-main font-semibold dark:text-amber-50'
                : 'text-inactive-link dark:text-slate-400 font-normal dark:hover:text-slate-300'
            }`}
          >
            {asideTitles[name]}
          </span>
        </div>
      )}
    </Link>
  )
}

export default MenuItem
